import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { CreateTimelinePayload, TimelineItem } from 'views/Tasks/Timeline/types';
import { normalizeTimelineId } from 'views/Tasks/Timeline/helpers';

export const createTimeline = async (
    { orgId, dealId, postData }: { orgId: string; dealId: number; postData: CreateTimelinePayload },
): Promise<TimelineItem> => {
    const response = await axiosInstance.post<TimelineItem>(API_ENDPOINTS.TIMELINES(orgId, dealId), postData);
    return normalizeTimelineId(response.data);
};

export const useCreateTimeline = () => useMutation({
    mutationFn: createTimeline,
});
